import React from 'react'
import routes from './config' 
import RouterView from './routerView.js'  
const routerList = [  
    ...routes
]
const ViewRouter = () => {
    return (
        <div>
            <RouterView route={routerList} /> 
        </div>
    )
}

export default ViewRouter
